import {Column} from 'native-base';
import {IVStackProps} from 'native-base/lib/typescript/components/primitives/Stack/VStack';
import React from 'react';
import {useSafeArea} from '@ui/provider/safe-area/use-safe-area';

const ButtonBottomWrapper = ({...restProps}: IVStackProps) => {
    const {bottom} = useSafeArea();

    return (
        <Column
            w={{
                base: 'full',
                lg: undefined,
            }}
            px={{
                base: '4',
                lg: '0',
            }}
            pt={{
                base: '4',
                lg: '0',
            }}
            bg={{
                base: 'white',
                lg: 'transparent',
            }}
            borderTopWidth={{
                base: '1px',
                lg: 0,
            }}
            borderColor='secondary.100'
            pb={bottom > 0 ? 0 : 4}
            safeAreaBottom
            {...restProps}
        />
    );
};

export default ButtonBottomWrapper;
